import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { label: '恋爱甜宠', path: '/category/romance' },
    { label: '热血动作', path: '/category/action' },
    { label: '悬疑惊悚', path: '/category/thriller' },
    { label: '奇幻冒险', path: '/category/fantasy' },
    { label: '都市生活', path: '/category/urban' },
    { label: '古风华韵', path: '/category/historical' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '用户协议', path: '/about#terms' },
    { label: '隐私政策', path: '/about#privacy' },
  ],
  social: [
    { label: '新浪微博', path: '#weibo' },
    { label: '微信公众号', path: '#wechat' },
    { label: 'QQ 群组', path: '#qq' },
    { label: '哔哩哔哩', path: '#bilibili' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-book-open-line text-primary-950 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                韩漫画网
              </span>
            </div>
            <p className="text-background-50/60 text-sm leading-relaxed mb-6">
              韩漫画网致力于为漫画爱好者提供最优质的韩漫阅读体验。
              下拉式完整版韩漫免费阅读，无删减漫画每日更新，
              海量韩国漫画资源尽在韩漫大全。
            </p>
          </div>

          <div>
            <h4 className="text-background-50/50 text-xs font-semibold uppercase tracking-wider mb-5">
              分类浏览
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.explore.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-background-50/70 hover:text-background-50 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50/50 text-xs font-semibold uppercase tracking-wider mb-5">
              关于
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-background-50/70 hover:text-background-50 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50/50 text-xs font-semibold uppercase tracking-wider mb-5">
              关注我们
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.social.map((link) => (
                <li key={link.path}>
                  <a
                    href={link.path}
                    className="text-background-50/70 hover:text-background-50 text-sm transition-colors duration-200"
                    rel="nofollow"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 py-10 md:py-14">
          <div className="overflow-hidden">
            <div className="font-heading text-[clamp(3rem,12vw,10rem)] font-black text-background-50/[0.04] tracking-tighter leading-none whitespace-nowrap select-none">
              韩漫画网 HANMANHUA
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/40 text-xs">
            &copy; {new Date().getFullYear()} 韩漫画网. 保留所有权利.
          </p>
          <p className="text-background-50/40 text-xs">
            韩漫免费阅读 | 无删减漫画 | 韩漫大全
          </p>
        </div>
      </div>
    </footer>
  );
}